import React from 'react';

function TextDelete({ previousData }) {
    return <p className={'body2 bg-pinka line-through break-words whitespace-pre-wrap w-fit h-fit'}>{previousData}</p>;
}

export default React.memo(TextDelete);
